import { throttle } from 'lodash';

import { Bucket } from './rate-limiter';

type Subscriber = (event: Record<string, Bucket>) => void;

export class RateLimiterChannel {
  #updatedAt = 0;
  #throttleDelay = 200;
  #channel: BroadcastChannel;
  #throttledPublish: (payload: Record<string, Bucket>, updatedAt: number) => void;

  #subscribers = new Set<Subscriber>();

  constructor(topic: string) {
    this.#channel = new BroadcastChannel(topic);
    this.#channel.onmessage = this.#handleMessage.bind(this);
    this.#throttledPublish = throttle(this.#postMessage.bind(this), this.#throttleDelay);
  }

  subscribe(callback: Subscriber) {
    this.#subscribers.add(callback);

    return () => {
      this.#subscribers.delete(callback);
    };
  }

  publish(payload: Record<string, Bucket>) {
    if (document.visibilityState === 'hidden') {
      return;
    }

    this.#updatedAt = Date.now();
    this.#throttledPublish(payload, this.#updatedAt);
  }

  #postMessage(payload: Record<string, Bucket>, updatedAt: number) {
    this.#channel.postMessage({ payload, updatedAt });
  }

  #handleMessage(event: MessageEvent) {
    if (event.data.updatedAt < this.#updatedAt) {
      return;
    }

    this.#updatedAt = event.data.updatedAt;

    for (const callback of this.#subscribers) {
      callback(event.data.payload);
    }
  }
}
